import { useEffect } from "react";
import MultiStepForm from "./MultiStepForm";
import { useSignUpContext } from "../../context/SignUpContext";


export default function DspOnboardingForm() {
  const { setSignUpDetails } = useSignUpContext();
  useEffect(() => {
    setSignUpDetails((prev) => ({
      first_name: "",
      last_name: "",
      mobile: "",
      email: "",
      password: "",
      countryCode: "+91",
      confirm_password: "",
      isEmailVerified: false,
      isMobileVerified: false,
    }))
  }, [])
  return (
    <div className="dsp-onboarding-form" style={{ width: "100%", height: "100%", padding: "10px 20px", background: "white" }}>
      <MultiStepForm />
    </div>
  )
}
